import { IEditTask, PlanActionTypes } from "../models/planActions";
import { EDIT_TASK } from "../types";

export default (data: IEditTask["payload"]): PlanActionTypes => ({
    type: EDIT_TASK,
    payload: data,
});